<ng-select
    class="environment-select"
    bindLabel="name"
    bindValue="code"
    data-cy="kmo-ui-environment-selected"
    [clearable]="false"
    [items]="environments"
    [ngModel]="currentEnvironment"
    (ngModelChange)="onEnvironmentChange($event)"
></ng-select>
